module.exports = __webpack_public_path__ + "img/face61.b097fb0e.gif";